module.exports = __webpack_public_path__ + "static/media/AragonTerminal.97ffde90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/BlockChain/AragonTerminal.png
// module id = 481
// module chunks = 0